
	import {
		Component,
		Model,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";

	@Component({
		name: 'picker-date',
	})
	export default class PickerDate extends Vue {
		@Model('change') time!: any;
		@Prop({
			default:false
		}) private ismultiple:boolean
		@Prop({
			default:false
		}) private canclose:boolean
		@Prop({
			default: 'input'
		}) private type!: string;
		@Prop({
			default: '请输入'
		}) private placeholder!: string;
		@Prop({
			default: '322px'
		}) private width!: string;
		@Prop({
			default: ''
		}) private mintext!: string;
		@Prop({
			default: ''
		}) private maxtext!: string;
		@Prop({
			default: '-'
		}) private spacetext!: string;
		@Prop({
			default: 'daterange'
		}) private datetype!: string;
		@Prop({
			default: 'yyyy-MM-dd'
		}) private format!: string;
		@Prop({
			default: ''
		}) private defaultTime!: string|string[];
		@Prop({
			default: ()=>{
				return []
			}
		}) private selectList!: any;
		private inputType = 0;
		private inputVal:any = '';
		private selectDate = '';

		@Watch('time')
		private onChangeVal(val: any) {
			this.inputVal = val;
			if (this.type !== 'select'){
				if (!val) {
					this.inputType = 0;
					this.inputVal = '';
					this.selectDate = '';
				}
			}
			// console.log(val,this.inputVal,1)
		}

		private emptyTime(){
			this.inputVal = ''
			this.$emit('emptyTime',this.inputVal)
			this.$emit('change', this.inputVal)
		}
		private created(){
			this.inputVal = this.time;
		}


		private handleChange(e: any) {
			if(this.datetype == 'month'){
				this.inputVal = e
			}else{
				this.inputVal = e.join('/')
			}
			this.returnVal()
		}

		private returnVal() {
			this.$emit('change', this.inputVal)
		}
		
		private selectChange(){
			// console.log(this.inputVal)
			this.$emit('change', this.inputVal)
		}
	}
